import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { checkTranslation, imageAddress, translate } from '../../utils/useful';

class FramesWidget extends Component {

    state = {
        tabs: 'applets',
    }

    componentDidMount() {
        // this.init()
        // console.log('this.props.inbox', this.props.inbox)
        this.main.addEventListener('wheel', this.onWheel, true)
    }


    componentWillUnmount() {
        this.main.removeEventListener('wheel', this.onWheel)
    }

    onWheel = (e) => {
        e.stopPropagation()
    }


    setHubs = () => {
        this.setState({ tabs: "hubs" })
    }

    setApplet = () => {
        this.setState({ tabs: "applets" })
    }

    openApplet = (username, urlcode) => {
        let path = [username, urlcode]
        this.props.addNewWindow('applet', { path: path })
    }


    iconSelector(type) {
        switch (type) {
            case 'collection':
                return '/assets/icons/applets/database.png'
                break;

            case 'folder':
                return '/assets/icons/folder (1).png'
                break;

            case 'page':
                return '/assets/icons/applets/notebook.png'
                break;



            default:
                return '/assets/icons/useful/pages.png'
                break;
        }
    }

    render() {

        let showModules = this.props.modules
        let page = this.props.page
        if (!page) {
            showModules = showModules.filter((a) => a.parents == null || a.parents?.length == 0)
        } else {
            showModules = showModules.filter((a) => Array.isArray(a.parents) && a.parents[a.parents.length - 1] == page._id)
        }

        // console.log("this.props.modules",this.props.modules)
        // console.log("showModules",showModules)

        return (
            <div className="w-100 h-100  d-flex flex-column sc-2 " style={{ justifyContent: 'space-between', }}>
                <div className="flexcb py-2 flex-wrap px-3 " style={{ borderBottom: '1px solid #eee' }}>
                    <p className="text-bold text-normal" style={{ whiteSpace: 'nowrap', }}>{translate("Explore frames")}</p>

                </div>
                <div className='w-100 px-2'>
                    <div className="flex-1  pt-0 sc-gray2 h-100" ref={el => this.main = el} style={{ maxHeight: '400px', overflow: 'auto', alignSelf: 'stretch', flex: 1, width: '100%' }}>

                        <div className="d-flex flex-wrap sc-gray2 flex-1 w-100  pb-3 px-1" ref={el => this.portalsContainer = el} style={{ overflowX: 'auto', }}>
                            {/* {this.props.modules?.map((item, index) => {
                                return (
                                    <div key={index} className="pb-1 pt-1" style={{ transition: 'all 0.5s', cursor: 'pointer', borderBottom: '1px solid #f6f6f6' }} onClick={() => this.openApplet(item.appletHub.username, item.applet.urlcode)} >
                                        <button onClick={() => this.props.onClick(item.key ?? item._id)} className="flexc" style={{ position: 'relative' }}>

                                            <div className="position-relative">
                                                <div className="flexcc" style={{ width: '40px', height: '40px', }}>
                                                    <img src={item.icon ?? this.iconSelector(item.type)} style={{ width: '30px', height: '30px', objectFit: "contain" }} alt='' />
                                                </div>
                                            </div>
                                            <div className='d-flex flex-column pld-3 text-start'>
                                                <p className="mb-0 font-size-14 text-bold" style={{ color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTranslation((item.title ?? item.name))}</p>
                                                <p className="mb-0 font-size-11 text-semibold" style={{ color: '#999', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTranslation(item.description)}</p>
                                            </div>

                                        </button>
                                    </div>
                                )
                            })} */}
                            {showModules.length == 0 && (
                                <div className='w-100 flexcc flex-column py-4'>
                                    <img src='/assets/icons/useful/planet.png' height={60} alt='' />
                                    <p className='text-center text-semibold text-normal mt-2'>{translate("Found Nothing")}</p>
                                </div>
                            )}


                            {showModules?.map((item, index) => {

                                let appletId = item.applet?._id ?? item.applet
                                let hub = item.hub?._id ?? item.hub
                                if (!hub) {
                                    hub = this.props.variables?.appletHub
                                }


                                return (

                                    <div key={index} className="pb-1 pt-1 d-flex flex-column mb-1 " style={{ width: '25%', transition: 'all 0.5s', cursor: 'pointer', borderBottom: '0px solid #f6f6f6' }}  >
                                        {/* onClick={() => this.openApplet(item.appletHub?.username, item.applet?.urlcode)} */}
                                        <button onClick={() => this.props.changePage(item.slug ?? item.key ?? item._id)} className="d-flex flex-column position-relative" style={{ position: 'relative' }}>

                                            <div className="flexcc mx-1" style={{ width: '40px', height: '40px', }}>
                                                <img src={item.icon ?? this.iconSelector(item.type)} style={{ width: '30px', height: '30px', objectFit: "contain" }} alt='' />
                                            </div>
                                            <div className='d-flex flex-column pld-3 text-start w-100 px-2'>
                                                <p className="mb-0 font-size-15 text-bold mt-1 w-100" style={{ color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTranslation((item.title ?? item.name))}</p>
                                                {item.description ? (
                                                    <p className="mb-0 font-size-11 text-semibold" style={{ color: '#999', }}>{checkTranslation(item.description)}</p>

                                                ) : (
                                                    <p className="mb-0 font-size-11 text-semibold" style={{ color: '#999', }}>{checkTranslation(item.type)} module</p>
                                                )}
                                            </div>

                                            {(this.props.inbox.object[appletId]?.frames?.[item._id]?.count > 0) && (
                                                <div className="br-30 flexcc px-1" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', position: 'absolute', top: 12, left: 40 }}>
                                                    <p className="white font-size-12 text-semibold">{this.props.inbox.object[appletId]?.frames?.[item._id]?.count}</p>
                                                </div>
                                            )}

                                            {item.inbox && hub && this.props.inbox.categorizer && this.props.inbox.categorizer[item.inbox]?.hubs && this.props.inbox.categorizer[item.inbox]?.hubs[hub]?.count > 0 && (
                                                <div className="br-30 flexcc px-1" style={{ backgroundColor: '#ee5050', minWidth: '20px', height: '20px', position: 'absolute', top: 12, left: 40 }}>
                                                    <p className="white font-size-12 text-semibold">{this.props.inbox.categorizer[item.inbox]?.hubs[hub]?.count}</p>
                                                </div>
                                            )}

                                        </button>


                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connection: state.connection, inbox: state.inbox, relations: state.relations })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(FramesWidget);